export default function BrandingPreview({ form, previewLogoUrl }) {
  const initial = (form.firm_name || "L").trim().charAt(0).toUpperCase() || "L";
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-4" data-testid="branding-preview">
      <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-3">Preview</div>
      <div className="flex items-center gap-3">
        {previewLogoUrl ? (
          <img
            src={previewLogoUrl}
            alt="Logo preview"
            className="w-12 h-12 rounded-lg object-cover border"
            style={{ borderColor: `${form.primary_color}99` }}
            data-testid="branding-preview-logo"
          />
        ) : (
          <div
            className="w-12 h-12 rounded-lg border flex items-center justify-center"
            style={{ borderColor: `${form.primary_color}99` }}
          >
            <span
              className="font-display font-bold text-lg"
              style={{ color: form.primary_color, letterSpacing: "-0.04em" }}
            >
              {initial}
            </span>
          </div>
        )}
        <div className="leading-tight">
          <div className="font-display font-bold text-lg">
            {form.firm_name || "Your Firm"}
          </div>
          {form.tagline ? (
            <div className="overline text-[10px]" style={{ color: `${form.primary_color}CC` }}>
              {form.tagline}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
